import { Box, Chip } from '@mui/material';

import { SectionTypesProps } from './LayoutSectionTypesChip.interface';

export const LayoutSectionTypesChip = ({
  sectionTypes = [],
}: SectionTypesProps) => {
  if (sectionTypes.length === 0) return null;

  const sortedSectionTypes = [...sectionTypes].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' }),
  );
  const [firstValue, ...restValues] = sortedSectionTypes;

  return (
    <>
      <Chip label={firstValue} size="small" />
      {restValues.length > 0 && (
        <Box ml={1}>
          <Chip label={`+ ${restValues.length}`} size="small" />
        </Box>
      )}
    </>
  );
};
